export default class mousePararax {
    constructor($contaner) {

        this.w;

        /* DOM */
        this.$target = $contaner.find(".js__mouse-para")

        /* module */


        /* STATUS */
        this.status = {
            obj :[]
        }
        this.mouse;

    }
    render(mouse){

        this.mouse = mouse;

        for(let i=0; this.$target.length>i; i++){
            let _$t = this.$target.eq(i);

            TweenMax.set(_$t,{
                x:(this.mouse.x - this.status.obj[i].posi.x)*this.status.obj[i].rate,
                y:(this.mouse.y - this.status.obj[i].posi.y)*this.status.obj[i].rate,
                z:Useragnt.ie||Useragnt.edge ? 0:1*Math.sin(this.mouse.x*-this.mouse.y*0.000008*this.status.obj[i].rateZ)
            })
        }


    }
    resize(w) {

        this.w = w;
        // this.wHalf = this.w / 2;

        for(let i=0; this.$target.length>i; i++){
            let _$t = this.$target.eq(i);
            this.status.obj[i] = {
                rate : _$t.data("rate"),
                rateZ : 0.07 - _$t.data("rate"),
                posi : {
                    y : _$t.position().top,
                    x : _$t.position().left,
                }
            }
        }



    }
}